<template>
  <div>
    <div class="tw-flex tw-justify-between tw-items-center tw-gap-2 tw-mb-8">
      <h1>{{ $t('adm.agency.companies.title') }}</h1>
      <i-button
        type="primary"
        size="medium"
        @click="isAddCompanyDialogOpen = true"
      >
        <icon-plus class="tw-mr-2" />
        {{ $t('adm.agency.companies.create_button') }}
      </i-button>
    </div>

    <div v-loading="isLoading">
      <AdministrationCompaniesFilters
        store-path="v2/admin/cms/agency/companies"
        class="tw-mb-8"
      />

      <div
        class="tw-overflow-auto"
      >
        <AdministrationTableList
          store-path="v2/admin/cms/agency/companies"
          list-relative-path="companies"
          list-item-component-name="AgencyCompaniesListItem"
          list-item-prop-name="company"
          :columns="columns"
        />
      </div>
      <AdministrationTablePagination
        store-path="v2/admin/cms/agency/companies"
        filter-relative-path="filters"
      />
    </div>

    <AddAgencyCompanyDialog
      :is-open="isAddCompanyDialogOpen"
      @close="isAddCompanyDialogOpen = false"
      @refresh="load"
    />
    <ForeignersMessagingPopover />
  </div>
</template>

<script>
import ForeignersMessagingPopover from '@/components/Foreigners/Messaging/ForeignersMessagingPopover.vue';
import AddAgencyCompanyDialog from '@/components/Administration/Agency/Companies/AddAgencyCompanyDialog.vue';
import { companiesTableColumns } from '@/components/Administration/Agency/Companies/constants';
import AdministrationTablePagination from '@/components/Administration/components/AdministrationTablePagination.vue';
import AdministrationTableList from '@/components/Administration/components/AdministrationTableList.vue';
import AdministrationCompaniesFilters
  from '@/components/Administration/components/AdministrationCompaniesFilters.vue';
import { mapState } from 'vuex';

export default {
  name: 'AgencyCompanies',
  components: {
    AdministrationTablePagination,
    AdministrationTableList,
    AdministrationCompaniesFilters,
    ForeignersMessagingPopover,
    AddAgencyCompanyDialog,
  },
  data() {
    return {
      isAddCompanyDialogOpen: false,
    };
  },
  computed: {
    ...mapState({
      filters: (state) => state.v2.admin.cms.agency.companies.filters,
      isLoading: (state) => state.v2.admin.cms.agency.companies.isLoading,
    }),
    columns() {
      return companiesTableColumns;
    },
  },
  watch: {
    filters: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },
  mounted() {
    this.load();
    this.$store.dispatch('v2/admin/cms/clients/companies/loadAllCompanies');
  },
  methods: {
    load() {
      this.$store.dispatch('v2/admin/cms/agency/companies/load');
    },
  },
};
</script>
